import React, { useState, useEffect } from 'react';

import { GeneralModal } from "components";
import { func_validation, isArrayNotEmpty, isNotNullUndefined } from 'functions';

import "assets/scss/components/modals/listBoxModal.scss";
import { ListBox } from 'components/form/ListBox';
import { Toaster } from 'components/notification/Toaster';


export function ListBoxModal(props) {
    const { 
        className,
        isModalVisible,

        title,
        
        header,

        topContent,
        bottomContent,

        initSelectedIndexes,
        isListBoxHeaderHidden,
        list,
        labelList,
        isListLoading, isListRadio,

        listBoxOptions = {},

        actionTxt,
        actionStatus,
        isActionLoading, isClosedOnSuccess,

        isInputRequired, isFormSubmissionAttempted, isDisabled,

        otherProps = {},

        // Functions
        handleOnConfirm = () => {}
    } = props;

    // Validate Props
    let title_validated = func_validation.isStringTrimNotEmpty(title)? title:"";
    let header_validated = func_validation.isStringTrimNotEmpty(header)? header:"";
    let list_validated = func_validation.isArrayNotEmpty(list)? list:[];
    let actionTxt_validated = func_validation.isStringTrimNotEmpty(actionTxt)? actionTxt:"";

    // States
    const [selectedData, setSelectedData] = useState([]);

    function getList() {
        if (props.getList)
            props.getList();
    }
    useEffect(() => {
        getList();
    }, []);
    useEffect(() => {
        if (func_validation.isBooleanTrueNotNullUndefined(actionStatus))
            getList();
    }, [actionStatus]);

    function onConfirm() {
        if (isNotNullUndefined(selectedData)) handleOnConfirm(selectedData);
        else {
            Toaster({
                type: "info",
                msg: "No changes made"
            })
        }
    }

    return (
        <GeneralModal
            modalWapperClassName={"component-listBoxModal " +
                (className? className + " ":"")}
            isModalVisible={isModalVisible}
            updateParentState={props.updateParentState}

            title={title_validated}

            // Header

            headerClassName={"component-listBoxModal-header"}
            headerCloseClassName={"component-listBoxModal-header-close"}

            // Body

            bodyClassName={"component-listBoxModal-body"}
            bodyWrapperClassName={"component-listBoxModal-bodyWrapper"}

            bodyHeaderClassName={"component-listBoxModal-bodyHeader"}

            contentClassName={"component-listBoxModal-bodyContent"}
            content={(
                <div className="component-listBoxModal-bodyContentWrapper d-flex flex-column">
                    {/* Top Content */}
                    {topContent}

                    <ListBox
                        title={header_validated}

                        isHeaderHidden={isListBoxHeaderHidden}
                        list={isArrayNotEmpty(list_validated) && isArrayNotEmpty(labelList)? 
                            labelList.map((name, idx) => {

                                return {
                                    label: name, 
                                    data: list_validated[idx],
                                    isSelected: isArrayNotEmpty(initSelectedIndexes)? initSelectedIndexes.indexOf(idx) != -1: false
                                }
                        }):[]}
                        isListLoading={isListLoading}

                        updateParentState={setSelectedData}
                        isResetRequired={isModalVisible}
                        isListRadio={isListRadio}

                        isInputRequired={isInputRequired}
                        isFormSubmissionAttempted={isFormSubmissionAttempted}
                        isDisabled={isDisabled}

                        {...listBoxOptions}
                    />

                    {/* Bottom Content */}
                    {bottomContent}
                </div>
            )}

            footerClassName={"component-listBoxModal-footer"}
            confirmButtonText={actionTxt_validated}
            confirmButtonProps={{
                isLoading: isActionLoading,
                isDisabled: isDisabled
            }}
            handleOnConfirm={onConfirm}
            isConfirmButtonVisible
            isConfirmSuccessful={isClosedOnSuccess}

            {...otherProps}
        />
    )
}